import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

// Utils
import { media } from "utils/media";

export const SigninContainer = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  background-color: ${props => props.theme.colors.white.colorWhite};
  min-height: 100vh;

  ${media.TABLET`
    padding: 0 25px;
  `};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 42px;
  flex-grow: 1;

  ${media.PHONE`
    justify-content: flex-start;
    gap: 24px;  
    margin-top: 143px;
  `};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  max-width: 720px;

  ${props =>
    props.isFormActive
      ? css`
          ${media.PHONE`
            flex-direction: column;
            gap: 0px;
          `};
        `
      : css`
          ${media.PHONE`
          flex-direction: column-reverse;
          gap: 24px;
        `};
        `}
`;

export const IntroTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`;

export const IntroTextBold = styled.p`
  color: ${props => props.theme.colors.blue.colorBlue10};
  text-align: center;
  font-family: Avenir;
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
`;

export const IntroText = styled.p`
  color: ${props => props.theme.colors.black.colorBlack300};
  text-align: center;
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.purple.colorPurple15};
  text-align: center;
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;

  :hover {
    color: ${props => props.theme.colors.purple.colorPurple15};
    font-weight: 900;
  }
`;

export const HorizontalDividerContainer = styled.span`
  display: none;

  ${media.PHONE`
    display: block;
    padding: 10px 0;

    span {
      color: ${props => props.theme.colors.black.colorBlack300};
      font-size: 12px;
      font-weight: 400;
    }
  `};
`;

export const VerticalDividerContainer = styled.span`
  padding-left: 14px;
  ${media.PHONE`
    display: none;
  `};
`;
